// Doit rester synchronisé avec /app/backend/server.py (constante DIPLOMAS).
export const DIPLOMAS = [
  { code: "APS", label: "APS" },
  { code: "SSIAP1", label: "SSIAP 1" },
  { code: "SSIAP2", label: "SSIAP 2" },
  { code: "SSIAP3", label: "SSIAP 3" },
  { code: "cynophile", label: "Agent cynophile" },
  { code: "SST", label: "SST" },
];

export const ID_DOC_TYPES = [
  { code: "CNI", label: "Carte nationale d'identité" },
  { code: "passeport", label: "Passeport" },
  { code: "titre_sejour", label: "Titre de séjour" },
  { code: "permis", label: "Permis de conduire" },
];

export const CONTRACT_TYPES = [
  { code: "CDI", label: "CDI", has_end: false },
  { code: "CDD", label: "CDD", has_end: true },
  { code: "interim", label: "Intérim", has_end: true },
  { code: "stage", label: "Stage", has_end: true },
  { code: "apprentissage", label: "Apprentissage", has_end: true },
];

export const contractTypeLabel = (code) => CONTRACT_TYPES.find((c) => c.code === code)?.label || code;
export const contractRequiresEnd = (code) => !!CONTRACT_TYPES.find((c) => c.code === code)?.has_end;

// Returns { status: "ok"|"warning"|"expired"|"none", days }
// warning si expiration <30j, expired si dépassé.
export function expiryStatus(dateStr) {
  if (!dateStr) return { status: "none", days: null };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const exp = new Date(dateStr);
  if (Number.isNaN(exp.getTime())) return { status: "none", days: null };
  const diffMs = exp.getTime() - today.getTime();
  const days = Math.ceil(diffMs / 86400000);
  if (days < 0) return { status: "expired", days };
  if (days <= 30) return { status: "warning", days };
  return { status: "ok", days };
}
